import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static classes = ["expanded"]

  toggle() {
    this.contentTarget.classList.add("blurred-message--expanded")
  }
}